// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 17) return "static/chunks/17-47b3d1e7e13b6e30.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"e4ddd798f516f744","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"22510abec56c566b","367":"bd592a9574661a0a","639":"e7b660adfa99260e","748":"740320083497b743"}[chunkId] + ".js";
};